<template>
  <el-dialog :title="formStore.type==='CREATE'?'新增合同':'编辑合同'" :visible.sync="dialogStore"
             custom-class="workbench-contract-dialog-container"
             width="580px" center>
    <el-select v-model="formStore.customer_id" filterable default-first-option remote
               :remote-method="handelRemoteCustomer" placeholder="请选择客户" style="width: 100%;"
               :disabled="!!fixCustomer || formStore.type !== 'CREATE'">
      <el-option v-for="item in optionsCustomers" :key="item.customer_id" :label="item.customer_name"
                 :value="item.customer_id"/>
    </el-select>
    <el-input v-model="formStore.covenant_title" placeholder="请输入合同标题" maxlength="50" show-word-limit
              style="margin: 14px 0;"/>
    <el-upload
        :key="key"
        ref="upload"
        action="/api/upload/file_uploader"
        :headers="Authorization"
        name="upload_file"
        :limit="5"
        :data="{ file_type: 'certificate', folder: 'covenants' }"
        :on-success="handleSuccessUpload"
        drag
        multiple
    >
      <i class="el-icon-upload"/>
      <div class="el-upload__text">将文件拖到此处或<em>点击上传</em>，最多上传 5 个</div>
      <div class="el-upload__tip" slot="tip">
        只能上传jpg/png/pdf/word文件，内容应为合同书、信件、电报、电传、传真等源文件或图片文件
      </div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {optionsSaleCustomers} from "@/api/customers";
import {orderCovenantFileList, orderCovenantStore} from "@/api/orderCovenant";
import {parseTime} from "@/utils";
import {getToken} from "@/utils/auth";

const Authorization = {Authorization: 'Bearer ' + getToken()}
const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const user_id = user.id
const ModelFormStore = {
  type: 'CREATE',
  remark: null,
  customer_name: null,
  customer_id: null,
  covenant_title: null,
  covenant_no: null,
  id: null,
}
export default {
  name: "contractStore",
  props: {
    fixCustomer: {
      type: [Boolean, Object],
      default() {
        return false
      }
    },
  },
  data() {
    return {
      Authorization,
      dialogStore: false,
      optionsCustomers: [],
      key: new Date().getTime(),
      formStore: {...{}, ...ModelFormStore},
    }
  },
  watch: {
    "formStore.customer_id"() {
      this.changeCustomer()
    },
    "fixCustomer.customer_id"() {
      this.setCustomer();
    },
    "dialogStore"(_) {
      if (_) {
        this.key = new Date().getTime();
        if (this.formStore.type === 'CREATE') {
          // 新增合同 重置表单
          this.formStore = {...{}, ...ModelFormStore}
        } else {
          // 编辑合同 获取已上传文件
          this.getFilesForEdit()
        }
        this.setCustomer();
      }
    }
  },
  mounted() {
    this.setCustomer();
  },
  methods: {
    setCustomer() {
      if (!this.fixCustomer) {
        return false;
      }
      this.optionsCustomers = [this.fixCustomer]
      this.formStore.customer_id = this.fixCustomer.customer_id
      this.formStore.customer_name = this.fixCustomer.customer_name
      this.changeCustomer()
    },
    bridgeToAdd() {
      this.formStore.type = "CREATE";
      this.dialogStore = true;
    },
    bridgeToEdit(form) {
      this.optionsCustomers = [{customer_id: form.customer_id, customer_name: form.customer_name}];
      this.formStore = {...{}, ...form}
      this.dialogStore = true;
    },
    /**
     * 编辑回显已上传文件
     * @returns {Promise<void>}
     */
    async getFilesForEdit() {
      const response = await orderCovenantFileList({covenant_id: this.formStore.id})
      const files = response.model || []
      this.$refs.upload.uploadFiles = files.map(file => {
        return {
          "status": "success",
          "name": file.name,
          "size": file.size,
          "percentage": 100,
          "uid": file.file_id,
          "response": {
            "id": file.file_id,
          }
        }
      })
    },
    handleSuccessUpload(response) {
      if (!response.success) {
        const files = []
        this.$refs.upload.uploadFiles.map((_) => {
          const res = _.response
          if (res && res.id) {
            files.push(_)
          }
        })
        this.$refs.upload.uploadFiles = files
        this.$message.warning(response.message)
        return false;
      }
    },
    /**
     * 自动生成合同标题
     * @returns {boolean}
     */
    changeCustomer() {
      const _this = this
      if (!_this.formStore.customer_id) {
        return false;
      }
      if (_this.formStore.type !== 'CREATE') {
        return false;
      }
      const obj = _this.optionsCustomers.find(_ => _.customer_id === _this.formStore.customer_id)
      if (!obj) {
        _this.showToast({h: this, icon: "el-icon-error", text: '客户选择操作异常！', duration: 2000});
        return false;
      }
      const time = parseTime(new Date().getTime(), '{m}{d}{h}{i}{s}')
      _this.formStore.customer_name = obj.customer_name
      _this.formStore.covenant_title = `${obj.customer_name}${time}协商证明`
    },
    async handelRemoteCustomer(query) {
      const response = await optionsSaleCustomers({customer_name: query, sale_id: user_id})
      this.optionsCustomers = response.model || []
    },
    getFiles() {
      const files = []
      if (this.$refs.upload && Array.isArray(this.$refs.upload.uploadFiles)) {
        this.$refs.upload.uploadFiles.map(({response}) => {
          if (response && response.id) {
            files.push({file_id: response.id})
          }
        })
      }
      return files;
    },
    /**
     * 确认保存
     * @returns {Promise<boolean>}
     */
    async handelStoreSure() {
      const params = {...{}, ...this.formStore}
      params.files = this.getFiles()

      if (!params.customer_id) {
        this.showToast({h: this, icon: "el-icon-error", text: '请选择客户', duration: 1000});
        return false;
      }
      if (!params.covenant_title) {
        this.showToast({h: this, icon: "el-icon-error", text: '请填写合同名称', duration: 1000});
        return false;
      }
      if (!params.files.length) {
        this.showToast({h: this, icon: "el-icon-error", text: '最少上传一个附件', duration: 1000});
        return false;
      }

      const response = await orderCovenantStore(params)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return false;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      this.$emit('success', response.model)
      this.dialogStore = false;
    },
  }
}
</script>
<style lang="scss">
.workbench-contract-dialog-container {
  .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
    }
  }
}
</style>
